module.exports = __webpack_public_path__ + "media/assets/icons/trophy-star-780b59eb5fa186d95d11d6c72d1db07e.svg";